import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      icon: 'Shield',
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      icon: 'CreditCard',
      title: 'Stripe Payments',
      description: 'Secure processing'
    },
    {
      icon: 'Users',
      title: '50K+ Gamers',
      description: 'Trusted community'
    },
    {
      icon: 'Star',
      title: '4.8/5 Rating',
      description: 'User satisfaction'
    }
  ];

  return (
    <div className="bg-muted/20 rounded-lg p-6">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">Join the Gaming Revolution</h3>
        <p className="text-sm text-muted-foreground">
          Thousands of gamers trust Solis Games for their gaming needs
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {trustBadges.map((badge, index) => (
          <div key={index} className="text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full mb-2">
              <Icon name={badge.icon} size={20} className="text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground">{badge.title}</h4>
            <p className="text-xs text-muted-foreground">{badge.description}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={12} />
            <span>24/7 Support</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="RefreshCw" size={12} />
            <span>30-Day Guarantee</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Smartphone" size={12} />
            <span>All Devices</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;
